import { createI18n } from 'vue-i18n'

import en from './locales/en'

// English-only for v1; the i18n machinery is retained so adding a locale is just a new file.
export type AvailableLocales = 'en'

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           'en',
    fallbackLocale:   'en',
    messages:         { en },
    availableLocales: ['en'],
})

export default i18n
